/* eslint react/no-danger: 'off' */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { ImageSvg } from '../image';

const PaymentSuccessSubscription = (props) => {
  const { verificationStatus, messagesCharacterLimit } = props;

  const thankYou = get(translations, 'txt: Paldies, ka iegādājies {:hostname} abonementu!', '')
    // .replace('{:hostname}', `<a href="/">${window.location.hostname}</a>`);
    .replace('{:hostname}', `<a href="/">${get(globals, 'currentDomainName', 'otrapuse.lv')}</a>`);

  let activeUntil = null;
  const subscriptionEndtime = get(globals, 'subscriptionEndtime', null);
  if (subscriptionEndtime) {
    const date = new Date(subscriptionEndtime * 1000);
    const dateString = `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}.`;
    // TODO '{:periods}' currently isn't used in actual translations for this key,
    // but if at some point it will be included, need to adjust it here too.
    activeUntil = get(translations, 'txt: Tu iegādājies abonementu {:periods} un Tavs profila abonements ir aktīvs līdz {:termins}!', '')
      .replace('{:termins}', dateString);
  }

  const verificationFeatures = [
    {
      id: 'view_other_user_photos',
      icon: 'icon-popup_icon_4',
      text: 'txt: skatīt citu lietotāju bildes',
    },
    {
      id: 'participate_in_discussions',
      icon: 'icon-popup_icon_3',
      text: 'txt: rakstīt tērzētavā',
    },
  ];

  if (messagesCharacterLimit) {
    verificationFeatures.push({
      id: 'send_messages',
      icon: 'icon-popup_icon_1',
      text: 'txt: rakstīt neierobežota garuma vēstules',
    });
  }

  return (
    <div className="mtm">
      <div dangerouslySetInnerHTML={{ __html: thankYou }} />
      <div dangerouslySetInnerHTML={{ __html: activeUntil }} />
      <div className="mtm">
        {(get(globals, 'hasVerification', false) && verificationStatus !== 'verified') ? (
          <div>
            <div>
              {get(translations, 'txt: Lai pilnvērtīgi izmantotu portālā', '')}
              &nbsp;
              <span className="tcg">{get(translations, 'txt: pieejamās funkcijas:', '')}</span>
            </div>
            <div className="dib tal mtxs mbxs">
              {verificationFeatures.map((feature) => (
                <div key={feature.id}>
                  <span className="prs">
                    <ImageSvg svg={feature.icon} iconClass="icon--paymentPopupIcon" full />
                  </span>
                  {`${get(translations, feature.text, feature.text)};`}
                </div>
              ))}
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: get(translations, 'txt: nepieciešams veikt profila verifikāciju.', ''),
              }}
            />
            <a href="/verification" className="btn btn--a btn--center mtm">
              <span className="tcl twb ttu">{get(translations, 'txt: Verificēt profilu', '')}</span>
            </a>
          </div>
        ) : (
          <a href="/">{get(translations, 'txt: Sākums', '')}</a>
        )}
      </div>
    </div>
  );
};

PaymentSuccessSubscription.propTypes = {
  verificationStatus: PropTypes.string,
  messagesCharacterLimit: PropTypes.number,
};

PaymentSuccessSubscription.defaultProps = {
  verificationStatus: '',
  messagesCharacterLimit: null,
};

export default PaymentSuccessSubscription;
